export const tempItems = [1, 2, 3];
export const skipFilterValueKeys = ['session', 'listdata', 'monthnumber', 'formatteddate', 'isset', 'activitytypeids'];
export const skipFilterValues = ['desc', 'asc'];
